/**
 * Service for managing follow/unfollow actions.
 *
 * Responsibilities:
 * - Follow a user with tracking metadata.
 * - Unfollow a user.
 */
import type { ApiClient } from "@/common/api/http/types";

interface IFollowUserParams {
  username: string;
  source: string;
  position: number;
  sourceId: string | null;
}

export default class FollowService {
  public constructor(private readonly client: ApiClient) {}

  async followUser({ username, source, sourceId, position }: IFollowUserParams): Promise<void> {
    return await this.client.put(`v1/me/follows/${username}`, {
      source,
      source_id: sourceId,
      position,
    });
  }

  async unfollowUser(username: string): Promise<void> {
    return await this.client.delete(`v1/me/follows/${username}`);
  }
}
